export class MRRItemEntity {
  date!: string
  data_type!: 'users' | 'economics'
  new!: number
  existing!: number
  churn!: number
  total!: number
  net_new!: number
  growth_rate!: number
  net_monthly!: number
  net_annually!: number
  lifetime_value!: number
}
